import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const outcomes = ['Volver a sentir ternura sin esfuerzo.', 'Recuperar mirada y complicidad.', 'Bajar la tensión del silencio.', 'Un camino claro para no volver a cero.'];
export function Outcome() {
  return <section className="py-12 px-4 bg-[#0a0a0f]" data-id="element-130">
      <div className="max-w-2xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-132">
          <h2 className="text-2xl font-serif text-white" data-id="element-133">
            ¿Qué logran en 7 días?
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-134">
          {outcomes.map((outcome, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-3 p-4 rounded-xl bg-[#1a1a24]/50 border border-[#ff2d7a]/10" data-id="element-135">
              <div className="w-6 h-6 rounded-full bg-[#ff2d7a]/20 flex items-center justify-center flex-shrink-0" data-id="element-136">
                <Check size={14} className="text-[#ff2d7a]" data-id="element-137" />
              </div>
              <p className="text-gray-200" data-id="element-138">{outcome}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}